;(function module() {
  angular.module('app.ui.form.ctrls').controller('ApplicationAgentController', [
    '$uibModalInstance',
    'applicationId',
    'consultant',
    'ApplicationAgentsApi',
    'logger',
    'applicationAgent',
    'agentsList',
    '$rootScope',
    function controller(
      $uibModalInstance,
      applicationId,
      consultant,
      ApplicationAgentsApi,
      logger,
      applicationAgent,
      agentsList,
      $rootScope
    ) {
      var vm = this
      $rootScope.$on('application-deleted', (event, {applicationDeleted}) => {
        if (applicationId === applicationDeleted) {
          logger.notify('error', 'Application Deleted by Other Admin')
          $uibModalInstance.dismiss('cancel')
        }
      })
      vm.applicationAgent = applicationAgent
      vm.agentsList = agentsList
      vm.applicationId = applicationId
      vm.consultant = consultant
      vm.agentsList = [
        {
          id: 0,
          name: 'Select None',
          email: 'none',
          ticked: !(vm.applicationAgent.length > 0),
        },
        ...vm.agentsList.map(agent => {
          return agent.email === consultant.employerAgentEmail ||
            agent.email === consultant.candidateAgentEmail
            ? undefined
            : {
                id: agent.id,
                name: agent.firstName + ' ' + agent.lastName,
                email: agent.email,
                ticked: Boolean(
                  vm.applicationAgent.find(email => email === agent.email)
                ),
              }
        }),
      ].filter(agent => agent)

      vm.cancel = () => {
        $uibModalInstance.dismiss('cancel')
      }

      vm.selectedAgent = selectedAgent => {
        vm.agentsList =
          selectedAgent.id === 0
            ? vm.agentsList.map(agent => {
                if (agent.id !== 0) agent.ticked = false
                return agent
              })
            : vm.agentsList.map(agent => {
                if (agent.id === 0) agent.ticked = false
                return agent
              })
      }

      vm.updateApplicationAgent = async selectedAgent => {
        const userIds = selectedAgent.map(({id}) => id)
        const selectedNone = userIds.some(id => id === 0)
        let oldAgentsId
        if (selectedNone)
          oldAgentsId = vm.applicationAgent.map(agent => {
            return vm.agentsList.find(({email}) => email === agent).id
          })
        const payload = {
          userIds: selectedNone ? oldAgentsId : userIds,
          follow: !selectedNone,
        }
        try {
          const {
            status,
          } = await ApplicationAgentsApi.updateApplicationFollowers(
            vm.applicationId,
            payload
          )
          if (status === 200) $uibModalInstance.close(selectedAgent)
        } catch (error) {
          logger.notify('error', error.data.message)
          $uibModalInstance.close(false)
        }
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/application/application-agent/application-agent.ctrl.js